import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Restaurants = () => {
  return (
    <div 
      className="min-h-screen py-8 px-4"
      style={{
        background: `
          radial-gradient(900px 600px at 10% 10%, #132552 0%, #0B1736 45%, #060f24 100%)
        `
      }}
    >
      <main className="max-w-7xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 mt-2">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Button>
        </Link>

        <div className="border border-[hsl(var(--line))] rounded-[14px] p-4 sm:p-6 md:p-12" style={{ boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)" }}>
          <h1 className="font-orbitron font-bold text-3xl sm:text-4xl md:text-5xl mb-6 leading-tight">
            Restaurant <span className="text-primary">Automation</span>
          </h1>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Challenge</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-4 leading-relaxed">
              Restaurant owners face constant pressure: high labor costs, staff turnover, inconsistent service during rushes, and slim profit margins. Every position you can't fill means slower table turns and lost revenue.
            </p>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Solution</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 leading-relaxed">
              Our Restaurant Bundle combines BellaBot Pro delivery robots with AI Voice systems for reservations and waitlist management, all integrated with your CRM for seamless operations.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">BellaBot Pro</h3>
                <p className="text-sm text-muted-foreground">Handles food delivery and bussing, freeing servers to focus on hospitality</p>
                <p className="text-primary font-bold mt-2 text-sm">Saves 2-3 hours per shift</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">AI Voice Reservations</h3>
                <p className="text-sm text-muted-foreground">24/7 phone answering, booking confirmations, and waitlist management</p>
                <p className="text-primary font-bold mt-2 text-sm">Captures 35-60% more calls</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">CRM Integration</h3>
                <p className="text-sm text-muted-foreground">Guest data, preferences, and automated follow-ups to build loyalty</p>
                <p className="text-primary font-bold mt-2 text-sm">+20% repeat customers</p>
              </div>
            </div>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">Results You Can Expect</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">10–15% increase in table turns during peak hours</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Reduce labor costs by $3,000–$5,000/month</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Never miss a reservation call again</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Consistent service quality regardless of staffing</span>
              </li>
            </ul>
          </section>

          <section className="text-center">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4 leading-tight">Ready to Transform Your Restaurant?</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 max-w-2xl mx-auto leading-relaxed">
              Book a demo and see how robots + AI can help you scale without adding headcount.
            </p>
            <Button 
              asChild
              size="lg"
              variant="secondary"
              className="font-extrabold rounded-xl glow-gold"
            >
              <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
                Schedule Restaurant Demo
              </a>
            </Button>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Restaurants;
